// 用户分析
import http from "@/jslibs/axios/http";

// 用户分析-用户数统计
export const userNumStats = (data) => http.post("/web/report/userNumStats", data);

// 用户分析-用户国家分布
export const userCountryDistribution = (data) => http.post("/web/report/userCountryDistribution", data);

// 用户分析-用户性别分布
export const userGenderDistribution = (data) => http.post("/web/report/userGenderDistribution", data);

// 用户分析-详细数据 分页
export const userStatList = (data) => http.post("/web/report/userStatList", data);

// 用户分析-用户趋势
export const userTrend = (data) => http.post("/web/report/userTrend", data);